import React from "react";
import style from "../ModalJobs/style.module.css";
import lang from "../../../../lang/lang";
import { useSelector } from "react-redux";

const ModalSuccess = ({ onClose }) => {
  const currentLanguage = useSelector(({ main }) => main.currentLanguage);
  const t = lang[currentLanguage] || lang.hy || {};

  return (
    <div className={style.modal_jobs_content_title}>
      <div onClick={() => onClose(false)} className={style.modal_jobs_close}>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16M16 1L1 16" stroke="#282828"></path>
        </svg>
      </div>

      <div className={style.modal_jobs_content_img}>
        <img src="https://vlv.am/public/img/Group5655.png" alt="" />
      </div>
      <span>{t.success_resume}</span>
      <div onClick={() => onClose(false)} className={style.modal_jobs_content_button}>
        {t.cv_ok_close || t.to_close || t.submit}
      </div>
    </div>
  );
};

export default ModalSuccess;
